import { Icon } from '@/component/atoms/Icon'

import S from './aiAnalysisBanner.style'

export const AiAnalysisBannerBase = ({
  className = '',
  children,
}: {
  className?: string
  children: React.ReactNode
}) => {
  return (
    <S.AiAnalysisBanner className={className}>
      <Icon name="ai_comment_mono" size={16} color={'var(--Colors-Purple-400)'} />
      {children}
    </S.AiAnalysisBanner>
  )
}

const AiAnalysisSecondarySecuringTypeSchoolTestBanner = ({
  className = '',
  forcedBreak = false,
}: {
  className?: string
  forcedBreak?: boolean
}) => {
  return (
    <AiAnalysisBannerBase className={className}>
      학교별 학력평가, 지필고사 데이터로 {forcedBreak && <S.ResponsiveBreak />}
      재구성한 기출유사 문제입니다.
    </AiAnalysisBannerBase>
  )
}

const AiAnalysisSecondarySecuringTypeWorkbookBanner = () => {
  return <AiAnalysisBannerBase>AI가 정밀 분석해 가장 유사한 문제를 뽑았어요.</AiAnalysisBannerBase>
}

export const AiAnalysisBanner = {
  SecondarySecuringTypeWorkbook: AiAnalysisSecondarySecuringTypeWorkbookBanner,
  SecondarySecuringTypeSchoolTest: AiAnalysisSecondarySecuringTypeSchoolTestBanner,
}
